export interface User {
    id: string;
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    nationalIdNumber: string;
    role?: string;
    gender?: string;
    profilePictureUrl?: string;
  }

  export interface AuthState {
    user: User | null;
    token: string | null;
    loading: boolean;
    error: string | null;
    isAuthenticated: boolean;
  }

  export const initialAuthState: AuthState = {
    user: null,
    token: null,
    loading: false,
    error: null,
    isAuthenticated: false
  };
